module.exports = __webpack_public_path__ + "static/img/Elliot-Yeo.c612e35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Elliot-Yeo.jpg
// module id = jD01
// module chunks = 0